/**
 * The angularjs states related to the module alcmeon-ai
 */
alcmeonAiStates.$inject = ['$stateProvider', '$urlRouterProvider'];
export function alcmeonAiStates($stateProvider, $urlRouterProvider) {
  // old ai-ssistant settings redirection, done 27/08/2024, remove after x months ?
  $urlRouterProvider.when('/{id}/fuse/parameters/ai-ssistant', [
    '$state',
    function ($state) {
      $state.go('auth.alcmeon.fuse.parameters.alcmeon-ai');
      return true;
    },
  ]);

  $stateProvider
    .state('auth.alcmeon.fuse.parameters.alcmeon-ai', {
      url: '/alcmeon-ai',
      views: {
        'container@auth': {
          controller: [
            '$state',
            function ($state) {
              // go to first tab by default
              $state.go('auth.alcmeon.fuse.parameters.alcmeon-ai.agents');
            },
          ],
        },
      },
    })

    // routes AJS for each NG tabs
    .state('auth.alcmeon.fuse.parameters.alcmeon-ai.agents', {
      url: '/agents',
      data: { selectedTab: 0 },
      views: {
        'container@auth': {
          template: '<angular-alcmeon-ai></angular-alcmeon-ai>',
        },
      },
    })

    .state('auth.alcmeon.fuse.parameters.alcmeon-ai.agents.create', {
      url: '/create',
      data: { create: true },
      views: {
        'container@auth': {
          template: '<angular-ai-agent-edit></angular-ai-agent-edit>',
        },
      },
    })

    .state('auth.alcmeon.fuse.parameters.alcmeon-ai.agents.edit', {
      url: '/edit/:id',
      data: { create: false },
      views: {
        'container@auth': {
          template: '<angular-ai-agent-edit></angular-ai-agent-edit>',
        },
      },
    })

    .state('auth.alcmeon.fuse.parameters.alcmeon-ai.knowledge-documents', {
      url: '/knowledge-documents',
      data: { selectedTab: 1 },
      views: {
        'container@auth': {
          template: '<angular-alcmeon-ai></angular-alcmeon-ai>',
        },
      },
    })

    .state('auth.alcmeon.fuse.parameters.alcmeon-ai.knowledge-documents.create', {
      url: '/create',
      data: { create: true },
      views: {
        'container@auth': {
          template: '<angular-knowledge-document-edit></angular-knowledge-document-edit>',
        },
      },
    })

    .state('auth.alcmeon.fuse.parameters.alcmeon-ai.knowledge-documents.edit', {
      url: '/edit/:uuid',
      data: { create: false },
      views: {
        'container@auth': {
          template: '<angular-knowledge-document-edit></angular-knowledge-document-edit>',
        },
      },
    })

    .state('auth.alcmeon.fuse.parameters.alcmeon-ai.setup', {
      url: '/setup',
      data: { selectedTab: 2 },
      views: {
        'container@auth': {
          template: '<angular-alcmeon-ai></angular-alcmeon-ai>',
        },
      },
    });
}
